/* War Dogs — card swatch image swap. Progressive enhancement only. */
(function () {
  function cardImage(swatchEl) {
    var wrapper = swatchEl.closest('.card-wrapper');
    return wrapper ? wrapper.querySelector('.card__media img') : null;
  }

  document.addEventListener(
    'mouseover',
    function (e) {
      var sw = e.target.closest('.wd-swatch');
      if (!sw) return;
      var url = sw.getAttribute('data-wd-img');
      var img = cardImage(sw);
      if (!url || !img) return;
      if (!img.dataset.wdOriginal) {
        img.dataset.wdOriginal = img.currentSrc || img.src;
        img.dataset.wdOriginalSrcset = img.getAttribute('srcset') || '';
      }
      img.setAttribute('srcset', '');
      img.src = url;
    },
    true
  );

  document.addEventListener(
    'mouseout',
    function (e) {
      var sw = e.target.closest('.wd-swatch');
      if (!sw) return;
      var group = sw.closest('[data-wd-swatches]');
      if (group && group.contains(e.relatedTarget)) return;
      var img = cardImage(sw);
      if (!img || !img.dataset.wdOriginal) return;
      img.src = img.dataset.wdOriginal;
      if (img.dataset.wdOriginalSrcset) {
        img.setAttribute('srcset', img.dataset.wdOriginalSrcset);
      }
    },
    true
  );
})();
